export default __webpack_public_path__ + "static/media/Video-call.052526cd.svg";